<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
    <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Control de facturas" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras las facturas creadas por usuarios."}}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0 py-0">
          <div style="width: 286px;">
            <v-autocomplete
              label="Selecciona un usuario"
              :items="users"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2"
              item-value="sCustomerEnterpriseId"
              item-text="sName"
              @change="getInvoicesHistory()"
              v-model="selectedUser"
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="items">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ "Usuario" }}</th>     
              <th class="header__title center">{{ "Proveedor" }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ "Fecha de creación" }}</th>                                                                                                                                                                       
              <th class="header__title center">{{ "Fecha de compra" }}</th>                                                                                                                                                                       
              <th class="header__title center">{{ "Fecha de vencimiento" }}</th>
              <th class="header__title center">{{ "Factura" }}</th>                                                                                                                                                                                                                          
              <th class="header__title center">{{ "Orden de compra" }}</th>
              <th class="header__title center">{{ "Estatus" }}</th>
              <th class="header__title center">{{ "Monto total" }}</th>
              <th class="header__title center">{{ "Tipo de cambio protegido" }}</th>
              <th class="header__title center">{{ "Monto protegido" }}</th>
              <th class="header__title right">{{ "Monto usado" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.CustomerEnterprises }}</td>
              <td class="table__item">{{ item.PaymentRecipient }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">{{ formatDate(item.dPurchaseDate) }}</td>
              <td class="table__item">{{ formatDate(item.dDueDate) }}</td>
              <td class="table__item">{{ item.sInvoice }}</td>
              <td class="table__item">{{ item.sId }}</td>
              <td class="table__item">
                <v-chip v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'" class="ma-2" color="primary" outlined>
                  {{ "To pay" }}
                </v-chip>
                <v-chip v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'" class="ma-2" outlined color="green">
                  {{ "Assigned" }}
                </v-chip>
                <v-chip v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'" class="ma-2" outlined color="#193D6E">
                  {{ "Paid" }}
                </v-chip>
              </td>
              <td class="table__item">{{  "$ " + formatMoney(item.dTotalAmount) + " MXN" }}</td>
              <td class="table__item">{{  "$ " + formatMoney(item.dRateProtection) + " MXN" }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dProtectedUsd) + " USD" }}</td>
              <td class="table__item">{{ "-" }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Usuario" }}</div>
                <div>{{ item.CustomerEnterprises }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Proveedor" }}</div>
                <div>{{ item.PaymentRecipient }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de creación" }}</div>
                <div>{{ formatDate(item.created_at) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de compra" }}</div>
                <div>{{ formatDate(item.dPurchaseDate) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de vencimiento" }}</div>
                <div>{{ formatDate(item.dDueDate) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Factura" }}</div>
                <div>{{ item.sInvoice }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Orden de compra" }}</div>
                <div>{{ item.sId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Estatus" }}</div>
                <div>
                  <v-chip v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'" class="ma-2" color="primary" outlined>
                    {{ "To pay" }}
                  </v-chip>
                  <v-chip v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'" class="ma-2" outlined color="green">
                    {{ "Assigned" }}
                  </v-chip>
                  <v-chip v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'" class="ma-2" outlined color="#193D6E">
                    {{ "Paid" }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto total" }}</div>
                <div>{{  "$ " + formatMoney(item.dTotalAmount) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de cambio protegido" }}</div>
                <div>{{  "$ " + formatMoney(item.dRateProtection) + " MXN" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto protegido" }}</div>
                <div>{{ "$ " + formatMoney(item.dProtectedUsd) + " USD" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto usado" }}</div>
                <div>{{ "-" }}</div>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "DashboardView",
  data() {
    return {
      nameXLSX: "HistorialConversiones.xlsx",
      users: [],
      selectedUser: "",
      isLoading: false,
      items: [],
    };
  },
  methods: {
    getUsers() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/en/administrator/users`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.users = response.data.results
        this.isLoading = false;
        
      }).catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getInvoicesHistory() {
      this.isLoading = true;

      const payload = {
        sEnterpriseId: this.selectedUser,
      };

      DB.post(`${URI}/api/v1/en/administrator/invoices`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.items = response.data.invoices
        this.isLoading = false;
      }).catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Client: item.CustomerEnterprises ? item.CustomerEnterprises : "",
            Supplier: item.PaymentRecipient ? item.PaymentRecipient : "",
            "Purchase date": item.created_at ? this.formatDate(item.created_at) : "",
            "Due date": item.dDueDate ? this.formatDate(item.dDueDate) : "N/A",
            Invoice: item.sInvoice ? item.sInvoice : "",
            "Purchase Order": item.sId ? item.sId : "",
            "Status": item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5' ? 'To Pay' : (item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005' ? 'Assigned' : (item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31' ? 'Paid' : "N/A")),
            "Total amount (MXN)": item.dTotalAmount ? parseFloat(item.dTotalAmount) : "",
            "Exchange rate protection": item.dRateProtection ? item.dRateProtection : "",
            "Currency profit (%)": item.dProfitPercentage ? parseFloat(item.dProfitPercentage) : "",
            "Currency gain (USD)": item.dCurrencyGain ? parseFloat(item.dCurrencyGain) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
  },
  beforeMount() {
    this.getUsers();
    this.getInvoicesHistory();
  },
};
</script>

<style>
</style>
